/**
 * 受众有关
 */
import request from 'src/utils/request';

export default {
  namespaced: true,

  actions: {
    getAudienceAnalysis({ commit }, url) {
      return request.get(url);
    },
  },
};
